import {
  apiClient,
  type CreateTariffImportJobDto,
  type TariffImportJobExEntity
} from '@/libs/api'

export type CreateTariffImportJobRequest = {
  tenantKey: string
  dto: CreateTariffImportJobDto
}

export const createTariffImportJob = async ({
  tenantKey,
  dto
}: CreateTariffImportJobRequest): Promise<TariffImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .tariffs.tariff_import.$post({
      body: dto
    })
  return data
}
